import { render, staticRenderFns } from "./PastCampaignsTable.vue?vue&type=template&id=308ef7a5&scoped=true"
import script from "./PastCampaignsTable.vue?vue&type=script&lang=js"
export * from "./PastCampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./PastCampaignsTable.vue?vue&type=style&index=0&id=308ef7a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ef7a5",
  null
  
)

export default component.exports